/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     增值管理
  +--------------------------------------------------------------------------------------
*/

const eiStore = {
  state: {
    deliveryTimeTypeArr: [
      {
        id: 1,
        value: "24小时内发货"
      },
      {
        id: 2,
        value: "48小时内发货"
      },
      {
        id: 3,
        value: "72小时内发货"
      },
      {
        id: 4,
        value: "3个工作日内发货"
      }
    ],
  },
  mutations: {
  },
  actions: {
  }
}

export default eiStore
